import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'

import cx from 'classnames'

import CardImage from '../CardImage'
import { Paragraph } from '../Contents'

import './styles.scss'

class AboutMe extends Component {

  static contextTypes = {
    staticData: PropTypes.array,
  }

  render () {
    const {
      staticData
    } = this.context

    const {
      imageContentID,
      paragraphContentID,
    } = this.props

    return (<div className="Atrakeur-AboutMe">
      <CardImage contentID={imageContentID} text="" rounded className="Atrakeur-AboutMe-Image"/>
      <Paragraph contentID={paragraphContentID} className="Atrakeur-AboutMe-Paragraph "/>
    </div>)
  }
}
export default AboutMe



// WEBPACK FOOTER //
// ./src/components/AboutMe/index.js